import { Suspense, lazy } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PublicRoute } from 'routing/components'
import homeRoutes from 'modules/Home/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const StaRedirect = lazy(
  () =>
    import(/* webpackChunkName: "StaRedirect" */ 'modules/redirects/StaRedirect/pages/StaRedirect')
)

const StaRedirectRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <PublicRoute exact path={routes.root} component={StaRedirect} />
      <Redirect path='*' to={homeRoutes.root} />
    </Switch>
  </Suspense>
)

export default StaRedirectRouting
